// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#education .wrapper{padding-top:20px}#education .wrapper p{margin-bottom:5px}#education .wrapper .university{font-family:\"HelveticaNeuyeCyr-Roman\",\"Helvetica\",sans-serif;font-weight:400}#education .wrapper:first-of-type{padding-top:0}#education .wrapper:not(:last-child){border-bottom:1px solid #e8e8ed;padding-bottom:15px}\n", ""]);
// Exports
module.exports = exports;
